import React from "react";
import PropTypes from 'prop-types';
import { Pagination, Stack } from "@mui/material";
import './pagination.scss'
// import { makeStyles } from "@material-ui/core";

const pagination = (props: { totalPages: any, handleChangePage: any, pageSize: any, pageNumber: any }) => {
    const { totalPages, handleChangePage, pageSize, pageNumber } = props;

    let NoOfPages = Math.ceil(Number(totalPages / pageSize));

    // const withStyles = makeStyles(() => ({
    //     root: {
    //         '& .MuiPaginationItem-root': {
    //             backgroundColor: 'transparent',
    //             color: '#ffffff',
    //         },
    //         '& .MuiPaginationItem-root.Mui-selected:hover': {
    //             backgroundColor: '#ebebeb',
    //             color: '#000000',
    //         },
    //         '& .MuiPaginationItem-root.Mui-selected': {
    //             backgroundColor: '#ebebeb',
    //             color: '#000000',
    //         }
    //     }
    // }),
    // );

    // const classes: any = withStyles;
    return (
        <Stack flexDirection='row' spacing={10} justifyContent='center'>
            <Pagination
                count={NoOfPages === 0 ? 1 : NoOfPages}
                // className={classes.root}
                className="pagination"
                onChange={handleChangePage}
                variant="outlined" shape="rounded"
                defaultPage={1}
                page={pageNumber}
            />
        </Stack>
    );
}

pagination.propTypes = {
    totalPages: PropTypes.number,
    handleChangePage: PropTypes.func,
}

export default pagination;